import { useContext, useEffect } from 'react';
import { AuthContext } from '../../context-providers';

export const useAuthContext = () => {
  const { setContextItems: setAuthData, contextItems: authData } = useContext(AuthContext);
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setAuthData(null);
    }
  });

  return {
    authData,
    setAuthData,
    isAuth: !!authData,
  };
};
